/**
 *
 * getErrorMessage
 * Message to show for a failed request. A 4xx response carries the API's own
 * explanation in its body (e.g. "Verification code has expired"); a 5xx body
 * is an internal error, so show the fallback; a network error has a browser
 * message such as "Failed to fetch".
 *
 */

async function readBody(response) {
  try {
    const isJson = /json/.test(response.headers.get('Content-Type'));
    const body = isJson ? await response.json() : await response.text();
    return typeof body === 'string' ? body : body?.message;
  } catch {
    return undefined;
  }
}

async function getErrorMessage(err, fallback) {
  const response = err?.response;
  if (!response) {
    return err?.message || fallback;
  }
  if (response.status >= 500) {
    return fallback;
  }
  return (await readBody(response)) || fallback;
}

export default getErrorMessage;
